import { render, staticRenderFns } from "./CorporateRegister.vue?vue&type=template&id=2c19f1e8"
import script from "./CorporateRegister.vue?vue&type=script&lang=ts"
export * from "./CorporateRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports